import { Button } from "@salesapp/ui";
import { useOptionalLoxley, type LoxleyRecord } from "./LoxleyProvider";

/**
 * Add a record to the Loxley chat and open the panel. Renders nothing when this user has no
 * Loxley seat or has hidden Loxley, so record screens can place it unconditionally.
 */
export function AskLoxleyButton({ record }: { record: LoxleyRecord }) {
  const loxley = useOptionalLoxley();
  if (!loxley?.available || loxley.hidden) return null;
  const added = loxley.pinned.some((item) => item.id === record.id);
  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      title={`Add ${record.label} to the Loxley chat so your questions are about this record.`}
      onClick={() => {
        loxley.pin(record);
        loxley.setOpen(true);
      }}
    >
      {added ? "In Loxley chat" : "Ask Loxley"}
    </Button>
  );
}
